/* @luxottica/vm-webcam v1.3.1 */
import { RemoteLogConfig, RemoteLog } from '@luxottica/vm-remotelog';
import uuid from 'uuid';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

const name="@luxottica/vm-webcam";const version="1.3.1";

var toDataURL = function toDataURL(url) {
  return fetch(url).then(function (response) {
    return response.blob();
  }).then(function (blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();

      reader.onloadend = function () {
        return resolve(reader.result);
      };

      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  });
};

var MockStreamTrack = /*#__PURE__*/function () {
  function MockStreamTrack() {
    _classCallCheck(this, MockStreamTrack);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "label", void 0);

    _defineProperty(this, "settings", void 0);

    this.id = uuid();
    this.label = 'mock-stream-track';
    this.settings = {};
  }

  _createClass(MockStreamTrack, [{
    key: "getSettings",
    value: function getSettings() {
      return this.settings;
    }
  }, {
    key: "stop",
    value: function stop() {
      return;
    }
  }]);

  return MockStreamTrack;
}();

var MockStream = /*#__PURE__*/function () {
  function MockStream(resolution) {
    _classCallCheck(this, MockStream);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "tracks", []);

    this.id = uuid();
    this.tracks.push(new MockStreamTrack());
  }

  _createClass(MockStream, [{
    key: "getTracks",
    value: function getTracks() {
      return this.tracks;
    }
  }, {
    key: "getVideoTracks",
    value: function getVideoTracks() {
      return this.tracks;
    }
  }]);

  return MockStream;
}();

var MockBridgeMedia = /*#__PURE__*/function () {
  function MockBridgeMedia() {
    _classCallCheck(this, MockBridgeMedia);
  }

  _createClass(MockBridgeMedia, [{
    key: "getUserMedia",
    value: function getUserMedia(constraints) {
      // const requiredResolution: any = this.getRequiredResolution(constraints);
      return new Promise(function (resolve, reject) {
        var videoSrc = localStorage.getItem('vm.mock.videoSrc');

        if (videoSrc === null) {
          reject(new Error('video src undefined'));
        } else {
          return toDataURL(videoSrc).then(function (dataUrl) {
            console.log('RESULT OK');
            resolve(new MockStream());
          })["catch"](function (e) {
            console.error(e);
          });
        }
      });
    }
  }]);

  return MockBridgeMedia;
}();

var AbstractNativeBridge = function AbstractNativeBridge() {
  _classCallCheck(this, AbstractNativeBridge);
};

_defineProperty(AbstractNativeBridge, "isNativeBridgePresent", void 0);

var NativeBridge = /*#__PURE__*/function (_AbstractNativeBridge) {
  _inherits(NativeBridge, _AbstractNativeBridge);

  var _super = _createSuper(NativeBridge);

  function NativeBridge() {
    var _this;

    _classCallCheck(this, NativeBridge);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onStartNativeCam", void 0);

    _defineProperty(_assertThisInitialized(_this), "onCamFrame", void 0);

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      window.webkit.messageHandlers.closeNativeCam.postMessage(undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "start", function (requiredResolution) {
      window.webkit.messageHandlers.startNativeCam.postMessage(requiredResolution);
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function () {
      // in old versions of native bridge there's no pause/resume support
      if (window.webkit.messageHandlers.pauseNativeCam) {
        window.webkit.messageHandlers.pauseNativeCam.postMessage(undefined);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resume", function () {
      // in old versions of native bridge there's no pause/resume support
      if (window.webkit.messageHandlers.resumeNativeCam) {
        window.webkit.messageHandlers.resumeNativeCam.postMessage(undefined);
      }
    });

    return _this;
  }

  _createClass(NativeBridge, null, [{
    key: "isNativeBridgePresent",
    value: function isNativeBridgePresent() {
      return _typeof(window.webkit) === 'object' && _typeof(window.webkit.messageHandlers) === 'object' && _typeof(window.webkit.messageHandlers.startNativeCam) === 'object';
    }
  }]);

  return NativeBridge;
}(AbstractNativeBridge);

var NativeStreamTrack = /*#__PURE__*/function () {
  function NativeStreamTrack(resolution) {
    _classCallCheck(this, NativeStreamTrack);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "label", void 0);

    _defineProperty(this, "settings", void 0);

    this.id = uuid();
    this.label = 'native-stream-track';
    this.settings = {
      height: resolution.height,
      width: resolution.width
    };
  }

  _createClass(NativeStreamTrack, [{
    key: "getSettings",
    value: function getSettings() {
      return this.settings;
    }
  }, {
    key: "stop",
    value: function stop() {
      window.NativeBridge.close();
    }
  }]);

  return NativeStreamTrack;
}();

var NativeStream = /*#__PURE__*/function () {
  function NativeStream(resolution) {
    _classCallCheck(this, NativeStream);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "tracks", []);

    this.id = uuid();
    this.tracks.push(new NativeStreamTrack(resolution));
  }

  _createClass(NativeStream, [{
    key: "getTracks",
    value: function getTracks() {
      return this.tracks;
    }
  }, {
    key: "getVideoTracks",
    value: function getVideoTracks() {
      return this.tracks;
    }
  }]);

  return NativeStream;
}();

var logger$1 = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'NativeBridgeMedia');

var NativeBridgeMedia = /*#__PURE__*/function () {
  function NativeBridgeMedia() {
    _classCallCheck(this, NativeBridgeMedia);

    _defineProperty(this, "remoteLog", new RemoteLog());
  }

  _createClass(NativeBridgeMedia, [{
    key: "getUserMedia",
    value: function getUserMedia(constraints) {
      var _this = this;

      logger$1.info('opening Native Camera with {}', JSON.stringify(constraints));
      var requiredResolution = this.getRequiredResolution(constraints);
      return new Promise(function (resolve, reject) {
        window.NativeBridge = new NativeBridge();
        window.NativeBridge.start(requiredResolution);

        window.NativeBridge.onStartNativeCam = function (resolution, error) {
          if (error) {
            var message = 'Error starting Native Camera -> ' + JSON.stringify(error);
            logger$1.error(message);

            _this.remoteLog.sendAppViewSession({
              statusCode: 'webcam-stream-error',
              statusText: message
            });

            reject(error);
          } else {
            logger$1.info('Started Native Camera');

            _this.remoteLog.sendAppViewSession({
              statusCode: 'webcam-stream',
              statusText: 'Started Native Camera'
            });

            resolve(new NativeStream(resolution));
          }

          window.NativeBridge.onStartNativeCam = undefined;
        };
      });
    }
  }, {
    key: "getRequiredResolution",
    value: function getRequiredResolution(constraints) {
      // tslint:disable-next-line:no-unnecessary-initializer
      var requiredResolution = null;

      if (constraints && constraints.video && typeof constraints.video !== 'boolean' && constraints.video.width && constraints.video.height) {
        var width = typeof constraints.video.width === 'number' ? constraints.video.width : constraints.video.width.ideal;
        var height = typeof constraints.video.height === 'number' ? constraints.video.height : constraints.video.height.ideal;
        requiredResolution = {
          resolution: {
            height: height,
            width: width
          }
        };
      }

      return requiredResolution;
    }
  }]);

  return NativeBridgeMedia;
}();

var UserMedia = /*#__PURE__*/function () {
  function UserMedia() {
    _classCallCheck(this, UserMedia);

    _defineProperty(this, "userMedia", void 0);

    _defineProperty(this, "mockOptionName", 'vm.mock.video');

    if (localStorage.getItem(this.mockOptionName) === 'true') {
      // mock enabled
      this.userMedia = new MockBridgeMedia();
    } else {
      this.userMedia = navigator.mediaDevices || new NativeBridgeMedia();
    }
  }

  _createClass(UserMedia, [{
    key: "get",
    value: function get() {
      return this.userMedia;
    }
  }]);

  return UserMedia;
}();

var MockVideoStream = /*#__PURE__*/function () {
  function MockVideoStream(options) {
    _classCallCheck(this, MockVideoStream);

    _defineProperty(this, "videoSrc", void 0);

    _defineProperty(this, "imageElement", void 0);

    _defineProperty(this, "privateCurrentTime", 0);

    _defineProperty(this, "mediaStream", void 0);

    _defineProperty(this, "playingListener", []);

    var videoSrc = localStorage.getItem('vm.mock.videoSrc');

    if (!!videoSrc) {
      this.videoSrc = videoSrc;
    } else {
      throw new Error('no video src defined');
    }

    this.imageElement = new Image();
    this.mediaStream = new MockStream();
  } // tslint:disable-next-line:max-line-length


  _createClass(MockVideoStream, [{
    key: "currentTime",
    get: function get() {
      this.privateCurrentTime++;
      return this.privateCurrentTime;
    }
  }, {
    key: "videoWidth",
    get: function get() {
      var _this$imageElement;

      return (_this$imageElement = this.imageElement) === null || _this$imageElement === void 0 ? void 0 : _this$imageElement.width;
    }
  }, {
    key: "videoHeight",
    get: function get() {
      var _this$imageElement2;

      return (_this$imageElement2 = this.imageElement) === null || _this$imageElement2 === void 0 ? void 0 : _this$imageElement2.height;
    }
  }, {
    key: "defaultMuted",
    get: function get() {
      // tslint:disable-next-line:no-console
      console.debug('This is a mock context, defaultMuted will always return true');
      return true;
    },
    set: function set(value) {
      // tslint:disable-next-line:no-console
      console.debug('This is a mock context, is not possible to set mute a video stream');
    }
  }, {
    key: "width",
    get: function get() {
      return this.imageElement.width;
    },
    set: function set(value) {
      // tslint:disable-next-line:no-console
      console.debug('This is a mock context, not possible to set image width');
    }
  }, {
    key: "height",
    get: function get() {
      return this.imageElement.height;
    },
    set: function set(value) {
      // tslint:disable-next-line:no-console
      console.debug('This is a mock context, not possible to set image height');
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener, options) {
      if (type === 'playing') {
        this.playingListener.push(listener);
      } else {
        listener();
      }
    } // tslint:disable-next-line:max-line-length

  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, options) {
      if (type === 'playing') {
        this.playingListener = [];
      }
    }
  }, {
    key: "play",
    value: function play() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.waitForFrame().then(function () {
          var _iterator = _createForOfIteratorHelper(_this.playingListener),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var listener = _step.value;
              listener();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          resolve();
        })["catch"](function () {
          reject();
        });
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      console.debug('This is a mock context, not possible to pause');
    }
  }, {
    key: "close",
    value: function close() {
      console.debug('This is a mock context, not possible to close');
    }
  }, {
    key: "image",
    get: function get() {
      return this.imageElement;
    }
  }, {
    key: "waitForFrame",
    value: function waitForFrame() {
      var _this2 = this;

      return toDataURL(this.videoSrc).then(function (imgData) {
        try {
          _this2.imageElement.setAttribute('src', imgData);
        } catch (error) {
          throw error;
        }
      });
    }
  }]);

  return MockVideoStream;
}();

var NativeVideoStream = /*#__PURE__*/function () {
  function NativeVideoStream(options, mediaStream) {
    var _this = this;

    _classCallCheck(this, NativeVideoStream);

    _defineProperty(this, "imageElement", void 0);

    _defineProperty(this, "privateCurrentTime", 0);

    _defineProperty(this, "mediaStream", void 0);

    _defineProperty(this, "playingListener", []);

    this.mediaStream = mediaStream;
    this.imageElement = new Image();
    this.imageElement.width = this.mediaStream.getVideoTracks()[0].getSettings().width;
    this.imageElement.height = this.mediaStream.getVideoTracks()[0].getSettings().height;

    window.NativeBridge.onCamFrame = function (base64) {
      _this.imageElement.src = base64;
    };
  } // tslint:disable-next-line:max-line-length


  _createClass(NativeVideoStream, [{
    key: "currentTime",
    get: function get() {
      return this.privateCurrentTime;
    }
  }, {
    key: "videoWidth",
    get: function get() {
      return this.imageElement.width;
    }
  }, {
    key: "videoHeight",
    get: function get() {
      return this.imageElement.height;
    }
  }, {
    key: "defaultMuted",
    get: function get() {
      // tslint:disable-next-line:no-console
      console.debug('This is a native context, defaultMuted will always return true');
      return true;
    },
    set: function set(value) {
      // tslint:disable-next-line:no-console
      console.debug('This is a native context, is not possible to set mute a video stream');
    }
  }, {
    key: "width",
    get: function get() {
      return this.imageElement.width;
    },
    set: function set(value) {
      // tslint:disable-next-line:no-console
      console.debug('This is a native context, not possible to set image width');
    }
  }, {
    key: "height",
    get: function get() {
      return this.imageElement.height;
    },
    set: function set(value) {
      // tslint:disable-next-line:no-console
      console.debug('This is a native context, not possible to set image height');
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener, options) {
      if (type === 'playing') {
        this.playingListener.push(listener);
      } else {
        listener();
      }
    } // tslint:disable-next-line:max-line-length

  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, options) {
      if (type === 'playing') {
        this.playingListener = [];
      } // mock

    }
  }, {
    key: "play",
    value: function play() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        window.NativeBridge.resume();

        _this2.waitForFrame().then(function () {
          _this2.startTimeCounter();

          var _iterator = _createForOfIteratorHelper(_this2.playingListener),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var listener = _step.value;
              listener();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          resolve();
        })["catch"](function () {
          reject();
        });
      });
    }
  }, {
    key: "pause",
    value: function pause() {
      window.NativeBridge.pause();
    }
  }, {
    key: "close",
    value: function close() {
      window.NativeBridge.close();
    }
  }, {
    key: "image",
    get: function get() {
      return this.imageElement;
    }
  }, {
    key: "waitForFrame",
    value: function waitForFrame() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.imageElement.onload = function () {
          resolve();
        };

        _this3.imageElement.onerror = function () {
          reject();
        };
      });
    }
  }, {
    key: "startTimeCounter",
    value: function startTimeCounter() {
      var _this4 = this;

      this.imageElement.onload = function () {
        _this4.privateCurrentTime++;
      };
    }
  }]);

  return NativeVideoStream;
}();

var WebCamVideoStream = /*#__PURE__*/function () {
  function WebCamVideoStream(options, mediaStream) {
    _classCallCheck(this, WebCamVideoStream);

    _defineProperty(this, "video", void 0);

    var targetElement = document.getElementById(options.target);

    if (!targetElement) {
      throw new Error('Impossible to start video on undefined element -> ' + options.target);
    }

    this.video = document.createElement('video');
    this.video.id = options.id || '';
    this.video.className = options.className || '';
    this.video.muted = true;
    this.video.setAttribute('playsinline', null);
    this.video.srcObject = mediaStream;
    targetElement.appendChild(this.video);
  } // tslint:disable-next-line:max-line-length


  _createClass(WebCamVideoStream, [{
    key: "currentTime",
    get: function get() {
      return this.video.currentTime;
    }
  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    }
  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }, {
    key: "defaultMuted",
    get: function get() {
      return this.video.defaultMuted;
    },
    set: function set(value) {
      this.video.defaultMuted = value;
    }
  }, {
    key: "width",
    get: function get() {
      return this.video.width;
    },
    set: function set(value) {
      this.video.width = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this.video.height;
    },
    set: function set(value) {
      this.video.height = value;
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, listener, options) {
      this.video.addEventListener(type, listener, options);
    } // tslint:disable-next-line:max-line-length

  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, options) {
      this.video.removeEventListener(type, listener, options);
    }
  }, {
    key: "play",
    value: function play() {
      return this.video.play();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    }
  }, {
    key: "image",
    get: function get() {
      return this.video;
    }
  }]);

  return WebCamVideoStream;
}();

var WebCamStream = /*#__PURE__*/function () {
  function WebCamStream(options, stream) {
    _classCallCheck(this, WebCamStream);

    _defineProperty(this, "mockOptionName", 'vm.mock.video');

    _defineProperty(this, "privateStreamObject", void 0);

    if (this.isMockStream()) {
      this.privateStreamObject = new MockVideoStream(options);
    } else if (this.isMediaStream(stream)) {
      this.privateStreamObject = new WebCamVideoStream(options, stream);
    } else {
      this.privateStreamObject = new NativeVideoStream(options, stream);
    }
  }

  _createClass(WebCamStream, [{
    key: "streamObject",
    get: function get() {
      return this.privateStreamObject;
    }
  }, {
    key: "close",
    value: function close() {
      if (this.privateStreamObject.constructor.name === WebCamVideoStream.name) {
        this.privateStreamObject.pause();
      } else {
        this.privateStreamObject.close();
      }
    }
  }, {
    key: "isMockStream",
    value: function isMockStream() {
      return localStorage.getItem(this.mockOptionName) === 'true';
    }
  }, {
    key: "isNativeStream",
    value: function isNativeStream() {
      return this.privateStreamObject.constructor.name === NativeStream.name;
    }
  }, {
    key: "isMediaStream",
    value: function isMediaStream(stream) {
      return stream.constructor.name === MediaStream.name;
    }
  }]);

  return WebCamStream;
}();

var defaultContraints = {
  audio: false,
  video: {
    facingMode: 'user',
    height: {
      ideal: 720,
      max: 720
    },
    width: {
      ideal: 1280,
      max: 1280
    }
  }
};
var cameraBlackList = ['Snap Camera'];

var WebCamConstraints = /*#__PURE__*/function () {
  function WebCamConstraints() {
    _classCallCheck(this, WebCamConstraints);
  }

  _createClass(WebCamConstraints, null, [{
    key: "getConstraints",
    value: function getConstraints(w, h, cameraFacingMode) {
      return WebCamConstraints.getDeviceIdConstraints().then(function (deviceIds) {
        return _objectSpread2(_objectSpread2({}, defaultContraints), {}, {
          audio: false,
          video: {
            deviceId: deviceIds,
            facingMode: cameraFacingMode,
            height: _objectSpread2(_objectSpread2({}, defaultContraints.video.height), {}, {
              ideal: h
            }),
            width: _objectSpread2(_objectSpread2({}, defaultContraints.video.width), {}, {
              ideal: w
            })
          }
        });
      });
    } // Filter out blacklisted cameras, for example we don't use want to use Snap Camera
    // The method leverage on navigator.mediaDevices and
    // there are two possible reasons for navigator.mediaDevices to not available:
    // 1 - the browser does not support webcams
    // 2 - the browser got a NativeBridge available
    // both points are handled by errors and NativeBridge so should be safe to return undefined in such cases

  }, {
    key: "getDeviceIdConstraints",
    value: function getDeviceIdConstraints() {
      return navigator.mediaDevices && navigator.mediaDevices.enumerateDevices().then(function (devices) {
        return devices.filter(function (device) {
          return device.kind === 'videoinput' && !cameraBlackList.includes(device.label);
        }).map(function (device) {
          return device.deviceId;
        });
      }) || Promise.resolve(undefined);
    }
  }]);

  return WebCamConstraints;
}();

var WebCamAbstractError = /*#__PURE__*/function (_Error) {
  _inherits(WebCamAbstractError, _Error);

  var _super = _createSuper(WebCamAbstractError);

  function WebCamAbstractError(error) {
    var _this;

    _classCallCheck(this, WebCamAbstractError);

    _this = _super.call(this, error);
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof WebCamAbstractError ? this.constructor : void 0).prototype);
    return _this;
  }

  return WebCamAbstractError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var WebCamAccessNotFoundError = /*#__PURE__*/function (_WebCamAbstractError) {
  _inherits(WebCamAccessNotFoundError, _WebCamAbstractError);

  var _super = _createSuper(WebCamAccessNotFoundError);

  function WebCamAccessNotFoundError() {
    _classCallCheck(this, WebCamAccessNotFoundError);

    return _super.call(this, 'webcam not found');
  }

  return WebCamAccessNotFoundError;
}(WebCamAbstractError);

var WebCamAccessRejectedError = /*#__PURE__*/function (_WebCamAbstractError) {
  _inherits(WebCamAccessRejectedError, _WebCamAbstractError);

  var _super = _createSuper(WebCamAccessRejectedError);

  function WebCamAccessRejectedError() {
    _classCallCheck(this, WebCamAccessRejectedError);

    return _super.call(this, 'webcam access was rejected');
  }

  return WebCamAccessRejectedError;
}(WebCamAbstractError);

var WebCamAccessSystemError = /*#__PURE__*/function (_WebCamAbstractError) {
  _inherits(WebCamAccessSystemError, _WebCamAbstractError);

  var _super = _createSuper(WebCamAccessSystemError);

  function WebCamAccessSystemError() {
    _classCallCheck(this, WebCamAccessSystemError);

    return _super.call(this, 'webcam system error');
  }

  return WebCamAccessSystemError;
}(WebCamAbstractError);

var AppViewSessionKeys;

(function (AppViewSessionKeys) {
  AppViewSessionKeys["WEBCAM_OK"] = "vm-webcam-ok";
  AppViewSessionKeys["WEBCAM_KO"] = "vm-webcam-ko";
  AppViewSessionKeys["WEBCAM_KO_REASON_MESS"] = "vm-webcam-ko_reason_mess";
  AppViewSessionKeys["WEBCAM_SIZE_W"] = "_webcam_size_w";
  AppViewSessionKeys["WEBCAM_SIZE_H"] = "_webcam_size_h";
  AppViewSessionKeys["WEBCAM_FRAMERATE"] = "_webcam_framerate";
  AppViewSessionKeys["WEBCAM_OPENED"] = "_webcam_opened";
  AppViewSessionKeys["WEBCAM_CLOSED"] = "_webcam_closed";
  AppViewSessionKeys["WEBCAM_OPENING"] = "_webcam_opening";
  AppViewSessionKeys["WEBCAM_OPENING_TIME"] = "_webcam_opening_time_s";
  AppViewSessionKeys["WEBCAM_POWERED_TIME"] = "_webcam_powered_time_s";
})(AppViewSessionKeys || (AppViewSessionKeys = {}));

var logger = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'WebCam');

var WebCam = /*#__PURE__*/function () {
  function WebCam() {
    _classCallCheck(this, WebCam);

    _defineProperty(this, "remoteLog", new RemoteLog());

    _defineProperty(this, "userMediaPromise", void 0);

    _defineProperty(this, "userReqPermissionTime", 0);

    _defineProperty(this, "userResPermissionTime", 0);
  }

  _createClass(WebCam, [{
    key: "tryToOpenWebCam",
    value: function tryToOpenWebCam(w, h, cameraFacingMode) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        WebCamConstraints.getConstraints(w, h, cameraFacingMode).then(function (constraints) {
          _this.tryToOpen(constraints).then(function (mediaStream) {
            return resolve(mediaStream);
          })["catch"](function (reason) {
            switch (reason.name) {
              case 'AbortError':
              case 'NotReadableError':
                reject(new WebCamAccessSystemError());

              case 'NotFoundError':
              case 'TypeError':
              case 'OverconstrainedError':
                reject(new WebCamAccessNotFoundError());

              case 'NotAllowedError':
              case 'SecurityError':
                reject(new WebCamAccessRejectedError());

              default:
                reject(new WebCamAccessSystemError());
            }
          });
        });
      });
    }
  }, {
    key: "closeCurrentMediaStream",
    value: function closeCurrentMediaStream() {
      var _this2 = this;

      if (this.userMediaPromise) {
        this.userMediaPromise.then(function (mediaStream) {
          try {
            mediaStream.getTracks().forEach(function (track) {
              var totalWebCamTime = _this2.streamOpenedTotalTime();

              logger.info('closing webcam mediastream {} track {} [after {} secs]', mediaStream.id, track.label, totalWebCamTime);
              track.stop();

              _this2.logCloseSucc(mediaStream.id, totalWebCamTime);
            });
          } catch (error) {
            logger.warn('error closing mediastream {} tracks', mediaStream.id);
          }
        })["catch"](function (reason) {
          logger.warn('error closing mediastream: {}', reason);
        });
      }
    }
  }, {
    key: "listMediaDevices",
    value: function listMediaDevices() {
      var devices = navigator.mediaDevices.enumerateDevices();
      devices.then(function (devicesInfo) {
        devicesInfo.forEach(function (deviceInfo) {
          logger.info('found {}: {}', deviceInfo.deviceId, deviceInfo.label);
        });
      });
    }
  }, {
    key: "createStreamObject",
    value: function createStreamObject(options, stream) {
      return new WebCamStream(options, stream);
    }
  }, {
    key: "tryToOpen",
    value: function tryToOpen(constraints) {
      var _this3 = this;

      logger.info('try to open webcam fow with constraints {}', JSON.stringify(constraints));
      this.remoteLog.sendAppViewSession({
        statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_OPENING,
        statusText: JSON.stringify(constraints)
      });
      this.userReqPermissionTime = performance.now();
      this.userMediaPromise = new UserMedia().get().getUserMedia(constraints);
      this.userMediaPromise.then(function (mediaStream) {
        _this3.userResPermissionTime = performance.now();

        var permissionWaitingTime = _this3.permissionWaitingTime();

        logger.info('webcam opened in {} secs [mediastream id: {}]', permissionWaitingTime, mediaStream.id);

        _this3.logOpenSucc(mediaStream.id, permissionWaitingTime);

        mediaStream.getVideoTracks().map(function (track) {
          _this3.logTrackSettings(track);
        });
      })["catch"](function (reason) {
        logger.warn('webcam not opened after {} secs ([{}] {})', _this3.permissionWaitingTime(), reason.name, reason.message);

        if (reason.constraintName) {
          logger.warn('failed constraint: {}' + reason.constraintName);
        }

        _this3.logOpenFail(reason);
      });
      return this.userMediaPromise;
    }
  }, {
    key: "logCloseSucc",
    value: function logCloseSucc(mediaStreamId, totalWebCamTime) {
      this.remoteLog.sendAppViewSession({
        statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_CLOSED,
        statusText: mediaStreamId
      }, {
        statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_POWERED_TIME,
        statusText: totalWebCamTime ? totalWebCamTime.toFixed(2) : 'n.a.'
      });
    }
  }, {
    key: "logOpenSucc",
    value: function logOpenSucc(mediaStreamId, permissionWaitingTime) {
      this.remoteLog.sendAppViewSession({
        statusCode: AppViewSessionKeys.WEBCAM_OK,
        statusText: mediaStreamId
      });
      this.remoteLog.sendAppViewSession({
        statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_OPENING_TIME,
        statusText: permissionWaitingTime ? permissionWaitingTime.toFixed(2) : 'n.a.'
      });
    }
  }, {
    key: "logOpenFail",
    value: function logOpenFail(reason) {
      this.remoteLog.sendAppViewSession({
        statusCode: AppViewSessionKeys.WEBCAM_KO,
        statusText: reason.name
      }, {
        statusCode: AppViewSessionKeys.WEBCAM_KO_REASON_MESS,
        statusText: reason.name + ': ' + reason.message
      });
    }
  }, {
    key: "logTrackSettings",
    value: function logTrackSettings(track) {
      if (track && track.getSettings()) {
        var deviceW = track.getSettings().width;
        var deviceH = track.getSettings().height;
        var wcamfps = track.getSettings().frameRate;
        logger.info('webcam mediastream track available \'{}\' [id {} - w {} - h {} - framerate {}]', track.label, track.id, deviceW, deviceH, wcamfps);
        this.remoteLog.sendAppViewSession({
          statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_SIZE_W,
          statusText: deviceW ? deviceW.toString() : 'n.a.'
        }, {
          statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_SIZE_H,
          statusText: deviceH ? deviceH.toString() : 'n.a.'
        }, {
          statusCode: AppViewSessionKeys.WEBCAM_OK + AppViewSessionKeys.WEBCAM_FRAMERATE,
          statusText: wcamfps ? Math.round(wcamfps).toString() : 'n.a.'
        });
      }
    }
  }, {
    key: "streamOpenedTotalTime",
    value: function streamOpenedTotalTime() {
      return this.userResPermissionTime === 0 ? 0 : (performance.now() - this.userResPermissionTime) / 1000;
    }
  }, {
    key: "permissionWaitingTime",
    value: function permissionWaitingTime() {
      return this.userReqPermissionTime === 0 ? 0 : (performance.now() - this.userReqPermissionTime) / 1000;
    }
  }]);

  return WebCam;
}();

export { NativeStream, WebCam, WebCamAbstractError, WebCamAccessNotFoundError, WebCamAccessRejectedError, WebCamAccessSystemError, WebCamStream };
//# sourceMappingURL=vm-webcam.js.map
